import { render } from "./NetworkNotSupported.vue?vue&type=template&id=e8f7f80e&scoped=true"
import script from "./NetworkNotSupported.vue?vue&type=script&lang=js"
export * from "./NetworkNotSupported.vue?vue&type=script&lang=js"

import "./NetworkNotSupported.vue?vue&type=style&index=0&id=e8f7f80e&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8f7f80e"]])

export default __exports__